import { TranslationsByLanguage } from './types';

export type HomeTranslationKey =
  | 'home.hero.title'
  | 'home.hero.subtitle'
  | 'home.hero.cta'
  | 'home.hero.exploreButton'
  | 'home.hero.loginButton'
  | 'home.popular.title'
  | 'home.popular.subtitle'
  | 'home.recent.title'
  | 'home.recent.subtitle'
  | 'home.channels.title'
  | 'home.channels.subtitle'
  | 'home.challenge.badge'
  | 'home.challenge.title'
  | 'home.challenge.description'
  | 'home.challenge.buttonText'
  | 'home.challenge.cashPrize'
  | 'home.challenge.deadline'
  | 'home.challenge.days'
  | 'home.challenge.hours'
  | 'home.challenge.minutes'
  | 'home.challenge.viewsRate';

export const homeTranslations: TranslationsByLanguage = {
  en: {
    'home.hero.title': 'Welcome to',
    'home.hero.subtitle': 'Discover, download, and remix protected content.',
    'home.hero.cta': 'Start Exploring',
    'home.hero.exploreButton': 'Explore',
    'home.hero.loginButton': 'Login',
    'home.popular.title': 'Popular Clips',
    'home.popular.subtitle': 'Most viewed and downloaded clips',
    'home.recent.title': 'Recent Additions',
    'home.recent.subtitle': 'Latest clips added to our collection',
    'home.channels.title': 'Featured Channels',
    'home.channels.subtitle': 'Explore our curated channels',
    'home.challenge.badge': 'Creative Challenge',
    'home.challenge.title': 'L\'amour c\'est surcoté',
    'home.challenge.description': 'Boost the film launch on TikTok with Studiocanal and ReCut. Use our exclusive clips to produce unique creations, grow your audience, and earn rewards.',
    'home.challenge.buttonText': 'Discover the challenge',
    'home.challenge.cashPrize': 'Cash Prize',
    'home.challenge.deadline': 'Start',
    'home.challenge.days': 'days',
    'home.challenge.hours': 'hours',
    'home.challenge.minutes': 'min',
    'home.challenge.viewsRate': '0.75€ per 1000 views',
  },
  fr: {
    'home.hero.title': 'Bienvenue chez',
    'home.hero.subtitle': 'Découvrez, téléchargez et remixez du contenu protégé.',
    'home.hero.cta': 'Commencer à Explorer',
    'home.hero.exploreButton': 'Explorer',
    'home.hero.loginButton': 'Connexion',
    'home.popular.title': 'Clips Populaires',
    'home.popular.subtitle': 'Clips les plus vus et téléchargés',
    'home.recent.title': 'Ajouts Récents',
    'home.recent.subtitle': 'Derniers clips ajoutés à notre collection',
    'home.channels.title': 'Chaînes en Vedette',
    'home.channels.subtitle': 'Explorez nos chaînes organisées',
    'home.challenge.badge': 'Challenge créatif',
    'home.challenge.title': 'L\'amour c\'est surcoté',
    'home.challenge.description': 'Boostez le lancement du film sur TikTok avec Studiocanal et ReCut. Utilisez nos extraits exclusifs pour produire des créations uniques, faites exploser votre audience et récoltez vos récompenses.',
    'home.challenge.buttonText': 'Découvrir le challenge',
    'home.challenge.cashPrize': 'Cash Prize',
    'home.challenge.deadline': 'Lancement',
    'home.challenge.days': 'jours',
    'home.challenge.hours': 'heures',
    'home.challenge.minutes': 'min',
    'home.challenge.viewsRate': '0.75€ par 1000 vues',
  }
};
